// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__3Ioup","header":"Card_header__3a9Ky","title":"Card_title__xxCb7","body":"Card_body__2OG0q","fadeIn":"Card_fadeIn__2AvHI","fadeOut":"Card_fadeOut__3-t3V"};